




































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit } from 'vue-property-decorator';
import { tickets, user } from '@/modules/shared/shared/store/namespaces';
import { GET_CUSTOMER_TYPE_ID, IS_EMPLOYEE } from '@/modules/users/store/user.getters';
import { CREATE_ACTION_OVER_ACCESS_PERMISSION } from '@/modules/tickets/shared/store/tickets.actions';
import {
    CAN_APPROVE_ACCESS_PERMISSION,
    CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL,
    GET_WORKFLOW_STEPS_ID,
    GET_ACCESS_PERMISSION_MOTIVES,
} from '@/modules/tickets/shared/store/tickets.getters';
import PDTChangeCommentSection from '@/modules/tickets/access-permissions/components/PDTChangeCommentSection.vue';
import PDTComments from '@/modules/tickets/access-permissions/components/PDTComments.vue';
import PDTFolks from '@/modules/tickets/access-permissions/components/PDTFolks.vue';
import PDTDescription from '@/modules/tickets/access-permissions/components/PDTDescription.vue';
import PDTWorkFlow from '@/modules/tickets/access-permissions/components/PDTWorkflow.vue';
import { WorkflowStates, Statuses } from '@/modules/shared/shared/domain/constants/constants';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {
        PDTChangeCommentSection,
        PDTComments,
        PDTWorkFlow,
        PDTFolks,
        PDTDescription,
    },
})
export default class PDTDetail extends Vue {
    comment: string = '';
    modalComment: boolean = true;
    writeChange: boolean = false;
    sendingApprovedReview: boolean = false;
    sendingNotApprovedReview: boolean = false;
    sendingChangesReview: boolean = false;
    action: string = '';
    notApprovedStatusId: number = Statuses.NOT_APPROVED.id;
    successReview: boolean = false;
    rules: any = rules;

    @Emit('closeAccessPermissionDetail')
    closeAccessPermissionDetail(successAction: boolean) {
        this.$emit('closeAccessPermissionDetail', successAction);
    }

    get workflowStepsObject() {
        return this.workflowSteps.map(workflowStep => ({
            id: workflowStep.id,
            workflowPreviousRole: {
                id: workflowStep.workflowPreviousRole,
            },
            workflowNextRole: {
                id: workflowStep.workflowNextRole,
            },
        }));
    }

    // TODO: Modificar el customerType al valor real
    @Emit('sendRequestForChange')
    async sendRequestForChange(comment, commentarySection) {
        const action = {
            workflowState: WorkflowStates.REQUEST_CHANGES.id,
            workflowSteps: this.workflowStepsObject,
            comment,
            commentarySection,
            accessPermission: {
                id: this.ticketDetail.accessPermission.id,
                accessMotives: this.GET_ACCESS_PERMISSION_MOTIVES,
                customerType: 3,
            },
        };

        this.sendingChangesReview = true;
        const fetched: boolean = await this.createActionOverAccessPermission(action);
        this.sendingChangesReview = false;

        if (!fetched) {
            this.action = 'solicitando ajustes';
        } else {
            this.successReview = true;
            setTimeout(() => {
                this.successReview = false;
                this.closeAccessPermissionDetail(true);
            }, 4000);
        }
    }

    get customerDetail() {
        if (this.IS_EMPLOYEE) {
            return `- ${this.ticketDetail.customer.name}`;
        } else {
            return '';
        }
    }

    async createActionOverAccessPermission(action) {
        return this.CREATE_ACTION_OVER_ACCESS_PERMISSION(action);
    }

    getCommentToSend() {
        if (this.CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL) {
            const comment: string = this.comment.trim();
            if (comment !== '') {
                return comment;
            }
        }
        return null;
    }

    // TODO: Modificar el customerType al valor real
    async approve() {
        const action = {
            workflowState: WorkflowStates.APPROVE.id,
            workflowSteps: this.workflowStepsObject,
            comment: this.getCommentToSend(),
            accessPermission: {
                id: this.ticketDetail.accessPermission.id,
                accessMotives: this.GET_ACCESS_PERMISSION_MOTIVES,
                customerType: 3,
            },
        };

        this.sendingApprovedReview = true;
        const fetched: boolean = await this.createActionOverAccessPermission(action);
        this.sendingApprovedReview = false;

        if (!fetched) {
            this.action = 'aprobando';
        } else {
            this.successReview = true;
            setTimeout(() => {
                this.successReview = false;
                this.closeAccessPermissionDetail(true);
            }, 4000);
        }
    }

    redirectToAccessPermissionsDashboard() {
        this.$router.push({
            name: 'access-permission-option2',
            params: {
                accessPermissionId: this.ticketDetail.accessPermission.id,
                review: 'success',
            },
        });
    }

    // TODO: Modificar el customerType al valor real
    async reject() {
        const action = {
            workflowState: WorkflowStates.REJECT.id,
            workflowSteps: this.workflowStepsObject,
            comment: this.getCommentToSend(),
            accessPermission: {
                id: this.ticketDetail.accessPermission.id,
                accessMotives: this.GET_ACCESS_PERMISSION_MOTIVES,
                customerType: 3,
            },
        };

        this.sendingNotApprovedReview = true;

        const fetched: boolean = await this.createActionOverAccessPermission(action);

        this.sendingNotApprovedReview = false;

        if (!fetched) {
            this.action = 'rechazando';
        } else {
            this.successReview = true;
            setTimeout(() => {
                this.successReview = false;
                this.closeAccessPermissionDetail(true);
            }, 4000);
        }
    }

    askForChange() {
        this.writeChange = !this.writeChange;
    }

    @tickets.State('ticketDetail') ticketDetail;
    @tickets.State('workflowSteps') workflowSteps;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
    @user.Getter(GET_CUSTOMER_TYPE_ID) GET_CUSTOMER_TYPE_ID;
    @tickets.Getter(GET_ACCESS_PERMISSION_MOTIVES) GET_ACCESS_PERMISSION_MOTIVES;
    @tickets.Getter(CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL)
    CAN_EMIT_COMMENTS_OVER_ACCESS_PERMISSION_APPROVAL;
    @tickets.Getter(CAN_APPROVE_ACCESS_PERMISSION) CAN_APPROVE_ACCESS_PERMISSION;
    @tickets.Getter(GET_WORKFLOW_STEPS_ID) GET_WORKFLOW_STEPS_ID;
    @tickets.Action(CREATE_ACTION_OVER_ACCESS_PERMISSION)
    CREATE_ACTION_OVER_ACCESS_PERMISSION;
}
